import { CfCoreGalleryImage } from '../../models/gallery/cf-core-gallery-image.model';
import { CfCoreGalleryOptions } from '../../models/gallery/cf-core-gallery-options.model';
import { CoreModel } from '../core/core.model';
export class GalleryModel extends CoreModel {
/**
 * <p>It is array of images objects of type CfCoreGalleryImage</p>
 * <h4>Single image object type declaration:</h4>
 * <ul>
 * <li><span><b>small</b>: string</span><p>Url used in thumbnails</p></li>
 * <li><span><b>medium</b>: string</span><p>Url used in image</p></li>
 * <li><span><b>big</b>: string</span><p>Url used in preview</p></li>
 * <li><span><b>description</b>: string</span><p>Description used in preview</p></li>
 * </ul>
 */
images: CfCoreGalleryImage[];
/**
 * <p>Options object of type CfCoreGalleryOptions:</p>
 * <ul>
 * <li><span><b>width</b>: string</span><p>Default value: 100% - gallery width</p></li>
 * <li><span><b>height</b>: string</span><p>Default value: 400px - gallery height</p></li>
 * <li><span><b>fullWidth</b>: boolean</span><p>Default value: false - sets the same width as browser</p></li>
 * <li><span><b>image</b>: boolean</span><p>Default value: true - enables or disables image</p></li>
 * <li><span><b>imagePercent</b>: number</span><p>Default value: 75 - percentage height</p></li>
 * <li><span><b>imageArrows</b>: boolean</span><p>Default value: true - enables or disables arrows</p></li>
 * <li><span><b>imageArrowsAutoHide</b>: boolean</span><p>Default value: false - enables or disables arrows auto hide</p></li>
 * <li><span><b>imageSwipe</b>: boolean</span><p>Default value: false - enables or disables swipe</p></li>
 * <li><span><b>imageAnimation</b>: string</span><p>
 * Default value: 'fade' - animation type. Types are: fade, slide, rotate, zoom.</p></li>
 * <li><span><b>imageSize</b>: string</span><p>Default value: cover - image size. Sizes are: cover and contain.</p></li>
 * <li><span><b>thumbnails</b>: boolean</span><p>Default value: true - enables or disables thumbnails</p></li>
 * <li><span><b>thumbnailsColumns</b>: number</span><p>Default value: 4 - columns count</p></li>
 * <li><span><b>thumbnailsRows</b>: number</span><p>Default value: 1 - rows count</p></li>
 * <li><span><b>thumbnailsPercent</b>: number</span><p>Default value: 25 - percentage height</p></li>
 * <li><span><b>thumbnailsMargin</b>: number</span><p>Default value: 10 - margin between thumbnails and image</p></li>
 * <li><span><b>thumbnailsArrows</b>: boolean</span><p>Default value: true - enables or disables arrows</p></li>
 * <li><span><b>thumbnailsArrowsAutoHide</b>: boolean</span><p>Default value: false - enables or disables arrows auto hide</p></li>
 * <li><span><b>thumbnailsSwipe</b>: boolean</span><p>Default value: false - enables or disables swipe</p></li>
 * <li><span><b>thumbnailMargin</b>: number</span><p>Default value: 10 - margin between images in thumbnails</p></li>
 * <li><span><b>preview</b>: boolean</span><p>Default value: true - enables or disables preview</p></li>
 * <li><span><b>previewDescription</b>: boolean</span><p>Default value: true - enables or disables description for images</p></li>
 * <li><span><b>previewSwipe</b>: boolean</span><p>Default value: false - enables or disables swipe</p></li>
 * <li><span><b>previewCloseOnClick</b>: boolean</span><p>Default value: false - enables or disables closing preview by click</p></li>
 * <li><span><b>previewKeyboardNavigation</b>: boolean</span><p>Default value:
 * false - enables or disables navigation by keyboard</p></li>
 * </ul>
 */
options?: CfCoreGalleryOptions;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function GalleryModel_tsickle_Closure_declarations() {
/**
 * <p>It is array of images objects of type CfCoreGalleryImage</p>
 * <h4>Single image object type declaration:</h4>
 * <ul>
 * <li><span><b>small</b>: string</span><p>Url used in thumbnails</p></li>
 * <li><span><b>medium</b>: string</span><p>Url used in image</p></li>
 * <li><span><b>big</b>: string</span><p>Url used in preview</p></li>
 * <li><span><b>description</b>: string</span><p>Description used in preview</p></li>
 * </ul>
 * @type {?}
 */
GalleryModel.prototype.images;
/**
 * <p>Options object of type CfCoreGalleryOptions:</p>
 * <ul>
 * <li><span><b>width</b>: string</span><p>Default value: 100% - gallery width</p></li>
 * <li><span><b>height</b>: string</span><p>Default value: 400px - gallery height</p></li>
 * <li><span><b>fullWidth</b>: boolean</span><p>Default value: false - sets the same width as browser</p></li>
 * <li><span><b>image</b>: boolean</span><p>Default value: true - enables or disables image</p></li>
 * <li><span><b>imagePercent</b>: number</span><p>Default value: 75 - percentage height</p></li>
 * <li><span><b>imageArrows</b>: boolean</span><p>Default value: true - enables or disables arrows</p></li>
 * <li><span><b>imageArrowsAutoHide</b>: boolean</span><p>Default value: false - enables or disables arrows auto hide</p></li>
 * <li><span><b>imageSwipe</b>: boolean</span><p>Default value: false - enables or disables swipe</p></li>
 * <li><span><b>imageAnimation</b>: string</span><p>
 * Default value: 'fade' - animation type. Types are: fade, slide, rotate, zoom.</p></li>
 * <li><span><b>imageSize</b>: string</span><p>Default value: cover - image size. Sizes are: cover and contain.</p></li>
 * <li><span><b>thumbnails</b>: boolean</span><p>Default value: true - enables or disables thumbnails</p></li>
 * <li><span><b>thumbnailsColumns</b>: number</span><p>Default value: 4 - columns count</p></li>
 * <li><span><b>thumbnailsRows</b>: number</span><p>Default value: 1 - rows count</p></li>
 * <li><span><b>thumbnailsPercent</b>: number</span><p>Default value: 25 - percentage height</p></li>
 * <li><span><b>thumbnailsMargin</b>: number</span><p>Default value: 10 - margin between thumbnails and image</p></li>
 * <li><span><b>thumbnailsArrows</b>: boolean</span><p>Default value: true - enables or disables arrows</p></li>
 * <li><span><b>thumbnailsArrowsAutoHide</b>: boolean</span><p>Default value: false - enables or disables arrows auto hide</p></li>
 * <li><span><b>thumbnailsSwipe</b>: boolean</span><p>Default value: false - enables or disables swipe</p></li>
 * <li><span><b>thumbnailMargin</b>: number</span><p>Default value: 10 - margin between images in thumbnails</p></li>
 * <li><span><b>preview</b>: boolean</span><p>Default value: true - enables or disables preview</p></li>
 * <li><span><b>previewDescription</b>: boolean</span><p>Default value: true - enables or disables description for images</p></li>
 * <li><span><b>previewSwipe</b>: boolean</span><p>Default value: false - enables or disables swipe</p></li>
 * <li><span><b>previewCloseOnClick</b>: boolean</span><p>Default value: false - enables or disables closing preview by click</p></li>
 * <li><span><b>previewKeyboardNavigation</b>: boolean</span><p>Default value:
 * false - enables or disables navigation by keyboard</p></li>
 * </ul>
 * @type {?}
 */
GalleryModel.prototype.options;
}

